// The `reviewed` interface (2026-10-19): which games the user has reviewed,
// a game being reviewed once its review screen has been opened at least
// once (the user: "reviewed means that the user accessed the game review
// screen at least once for the given game"). The provider (review-visits
// today) keeps the record and marks a game as its review opens; Home's game
// strip (shared-game-bar) reads it to put a dot on the games not reviewed yet.

export const REVIEWED_API = 'reviewed';
export const REVIEWED_VERSION = '1.0.0';

export interface Reviewed {
  /** Resolves once the record is read. */
  ready(): Promise<void>;
  /** Whether the game's review screen was ever opened. */
  has(gameId: string): boolean;
  /** Marks a game reviewed; a no-op when it is already. */
  mark(gameId: string): void;
  /** Hears every change; returns the unsubscribe. */
  subscribe(listener: () => void): () => void;
}
